import PropTypes from 'prop-types';
import React from 'react';

import FormComponent from './FormComponent';

export default class FormWrapper extends FormComponent {

    static propTypes = {
        submitted: PropTypes.bool,
        className: PropTypes.string,
        children: PropTypes.any
    };

    static defaultProps = {
        submitted: false,
        className: '',
    };

    state = {
        submitted: this.props.submitted
    };

    UNSAFE_componentWillUpdate ({ submitted }) {
        if (submitted !== this.state.submitted) {
            this.setState({ submitted });
        }
    }

    _formRef = null;

    captureFormRef = (element) => {
        this._formRef = element;
    };

    render () {
        return (
            <div className={ this.props.className } ref={ this.captureFormRef }>
                { this.props.children }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/form/FormWrapper.js